import { Background, FloatingSquareImage, HeaderWrapper, MainContainer } from '../components/projects'
import { useState } from 'react'
import { slides } from '../data'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import { Captions } from 'yet-another-react-lightbox/plugins'
import 'yet-another-react-lightbox/plugins/captions.css'
import Gallery from '../components/atoms/gallery'
import { Header64, Paragraph16 } from '../styles/typography'
import blueBox from '../assets/images/blue-box1.png'

export const Projects = () => {
    const [index, setIndex] = useState<number>(-1)
    return (
        <>
            <Background>
                <MainContainer>
                    {/* <FloatingSquareImage src={blueBox} /> */}
                    <HeaderWrapper>
                        <Header64 style={{ marginTop: '-20px', marginBottom: '-10px', color: '#324C77' }}>
                            Featured Projects
                        </Header64>
                        <Paragraph16 style={{ color: '#63665B', textAlign: 'justify' }}>
                            At JB Fine Line Construction, our work speaks for itself. Each project showcases our
                            dedication to quality, precision, and lasting craftsmanship. Explore some of the builds that
                            highlight how we transform plans into enduring spaces designed with care.
                        </Paragraph16>
                    </HeaderWrapper>
                    <Gallery data={slides} onClick={(currentIndex: number) => setIndex(currentIndex)} />
                    <Lightbox
                        plugins={[Captions]}
                        // captions={{ showToggle: true }}
                        index={index}
                        open={index >= 0}
                        slides={slides}
                        close={() => setIndex(-1)}
                    />
                </MainContainer>
            </Background>
        </>
    )
}
